var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMobileIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3V17C13 18.1046 12.1046 19 11 19H3C1.89543 19 1 18.1046 1 17V3C1 1.89543 1.89543 1 3 1H11C12.1046 1 13 1.89543 13 3",
    stroke: "#201CE4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5H9",
    stroke: "#201CE4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMobileIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MobileIcon.ebdc2199.svg";
export { ForwardRef as ReactComponent };